module.exports = "<div>\n    <div *ngIf=\"operation\"\n         class=\"dx-progressbar-status progress-message\">{{operation}}</div>\n    <div class=\"progress-bar\">\n        <dx-progress-bar [height]=\"height\"\n                         [min]=\"min\"\n                         [max]=\"max\"\n                         [value]=\"value\"\n                         [statusFormat]=\"format\">\n        </dx-progress-bar>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/progress-bar/progress-bar.component.html
// module id = ./src/app/components/progress-bar/progress-bar.component.html
// module chunks = main